import React from 'react';
import { string, bool } from 'prop-types';
import { Link } from 'react-router';
import cx from 'classnames';

import IconOk from 'icons/panel-route.inline.svg';
import IconDisconnected from 'icons/panel-route-broken.inline.svg';
import IconPanelSwitch from 'icons/panel-switch.inline.svg';
import styles from './RouteHeader.scss';

export default function RouteHeader({ fromName, toName, status, oppositeRouteId, isLoading }) {
  return (
    <div
      className={cx(styles.main, {
        [styles.isLoading]: isLoading,
      })}
    >
      <header className={styles.header}>
        <h1 className={styles.title}>Route</h1>
      </header>

      <div className={styles.content}>
        <div className={styles.icon}>
          {status !== 'disconnected' ? <IconOk height={72} /> : <IconDisconnected height={72} />}
        </div>

        <h1 className={styles.text}>
          <div className={styles.textGroup}>
            <div className={styles.label}>from</div>
            <div className={styles.name}>
              {fromName}
            </div>
          </div>
          <div className={styles.textGroup}>
            <div className={styles.label}>to</div>
            <div className={styles.name}>
              {toName}
            </div>
          </div>
        </h1>

        {oppositeRouteId &&
          <div className={styles.switchButtonWrapper}>
            <Link to={`/map/live/routes/${oppositeRouteId}`} className={styles.switchButton}>
              <IconPanelSwitch className={styles.switchButtonIcon} style={{ width: '1.5em' }} />
            </Link>
          </div>}
      </div>
    </div>
  );
}

RouteHeader.propTypes = {
  fromName: string.isRequired,
  toName: string.isRequired,
  status: string.isRequired,
  oppositeRouteId: string,
  isLoading: bool,
};



// WEBPACK FOOTER //
// ./src/components/DataPanel/Details/RouteHeader/index.js